import { IKpiSearchParams } from '../../page/page-storage/kpi/kpi.types';
import { IMeeting } from '../../resource/meeting/meeting.types';
import { IApiRequestConfig } from '../api.types';

export const getKpisApi = (meetingId: IMeeting['id'], searchParams?: IKpiSearchParams): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'fetchKpisApi',
  uri: 'json',
  action: `meetings/${meetingId}/kpis`,
  method: 'get',
  params: searchParams,
  v2: true,
});
